(function () {
  function cartAddUrl() {
    return (window.__glowRoutes && window.__glowRoutes.cartUrl ? window.__glowRoutes.cartUrl : "/cart") + "/add.js";
  }

  function addToCart(variantId, quantity) {
    return fetch(cartAddUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 }),
    }).then(function (res) {
      if (!res.ok) throw new Error("Failed to add to cart");
      return res.json();
    });
  }

  function moneyFromCents(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
    } catch (e) {}
    return "$" + (Number(cents) / 100).toFixed(2);
  }

  function initVariantModal(section) {
    var variantModal = document.querySelector("[data-chemical-variant-modal]");
    if (!variantModal) return null;

    var variantModalTitle = variantModal.querySelector("[data-variant-modal-title]");
    var variantModalOptions = variantModal.querySelector("[data-variant-modal-options]");
    var variantModalError = variantModal.querySelector("[data-variant-modal-error]");
    var variantModalSubmit = variantModal.querySelector("[data-variant-modal-submit]");
    var activeProductData = null;
    var selectedOptions = [];
    var activeTriggerBtn = null;

    function getProductData(btn) {
      var card = btn.closest("[data-product-card]");
      if (!card) return null;
      var script = card.querySelector("[data-chemical-product-json]");
      if (!script) return null;
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        return null;
      }
    }

    function findMatchingVariant(product, options) {
      if (!product || !product.variants) return null;
      return (
        product.variants.find(function (variant) {
          return options.every(function (value, index) {
            var key = "option" + (index + 1);
            return !value || variant[key] === value;
          });
        }) || null
      );
    }

    function optionValuesForIndex(product, optionIndex) {
      var values = [];
      product.variants.forEach(function (variant) {
        var value = variant["option" + (optionIndex + 1)];
        if (value && values.indexOf(value) === -1) values.push(value);
      });
      return values;
    }

    function isOptionAvailable(product, optionIndex, value) {
      return product.variants.some(function (variant) {
        if (!variant.available) return false;
        if (variant["option" + (optionIndex + 1)] !== value) return false;
        return selectedOptions.every(function (selected, idx) {
          if (idx === optionIndex || !selected) return true;
          return variant["option" + (idx + 1)] === selected;
        });
      });
    }

    function requiredOptionIndexes(product) {
      var indexes = [];
      (product.options || []).forEach(function (name, index) {
        if (name !== "Title") indexes.push(index);
      });
      return indexes;
    }

    function getModalCartIconSrc() {
      var triggerImg = activeTriggerBtn && activeTriggerBtn.querySelector("img");
      if (triggerImg) return triggerImg.getAttribute("src") || "";
      var submitImg = variantModalSubmit && variantModalSubmit.querySelector("img");
      return submitImg ? submitImg.getAttribute("src") || "" : "";
    }

    function setModalSubmitLabel(label) {
      if (!variantModalSubmit) return;
      var iconSrc = getModalCartIconSrc();
      variantModalSubmit.innerHTML =
        label + (iconSrc ? ' <img src="' + iconSrc + '" alt="" width="20" height="20" />' : "");
    }

    function syncModalSubmitState() {
      if (!variantModalSubmit || !activeProductData) return;
      var required = requiredOptionIndexes(activeProductData);
      var allSelected = required.every(function (index) {
        return Boolean(selectedOptions[index]);
      });
      var match = allSelected ? findMatchingVariant(activeProductData, selectedOptions) : null;
      var ready = Boolean(match && match.available);

      variantModalSubmit.disabled = !ready;
      if (ready) {
        setModalSubmitLabel("Add to cart · " + moneyFromCents(match.price));
      } else {
        setModalSubmitLabel("Add to cart");
      }
    }

    function renderVariantOptions() {
      if (!variantModalOptions || !activeProductData) return;
      variantModalOptions.innerHTML = "";

      activeProductData.options.forEach(function (optionName, optionIndex) {
        if (optionName === "Title") return;

        var values = optionValuesForIndex(activeProductData, optionIndex);
        if (!values.length) return;

        var group = document.createElement("div");
        group.className = "collection-variant-modal__group";

        var label = document.createElement("span");
        label.className = "collection-variant-modal__group-label";
        label.textContent = optionName;
        group.appendChild(label);

        var grid = document.createElement("div");
        grid.className = "collection-variant-modal__grid";
        grid.setAttribute("data-count", String(Math.min(values.length, 3)));

        values.forEach(function (value) {
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "collection-variant-modal__option";
          btn.textContent = value;
          btn.disabled = !isOptionAvailable(activeProductData, optionIndex, value);
          if (selectedOptions[optionIndex] === value) btn.classList.add("is-active");

          btn.addEventListener("click", function () {
            selectedOptions[optionIndex] = value;
            if (variantModalError) {
              variantModalError.hidden = true;
              variantModalError.textContent = "";
            }
            renderVariantOptions();
            syncModalSubmitState();
          });

          grid.appendChild(btn);
        });

        group.appendChild(grid);
        variantModalOptions.appendChild(group);
      });

      syncModalSubmitState();
    }

    function openVariantModal(productData, triggerBtn) {
      activeProductData = productData;
      activeTriggerBtn = triggerBtn;
      selectedOptions = productData.options.map(function () {
        return "";
      });

      if (variantModalTitle) variantModalTitle.textContent = productData.title || "Select options";
      if (variantModalError) {
        variantModalError.hidden = true;
        variantModalError.textContent = "";
      }

      renderVariantOptions();
      variantModal.hidden = false;
      document.body.classList.add("is-menu-open");
    }

    function closeVariantModal() {
      variantModal.hidden = true;
      document.body.classList.remove("is-menu-open");
      activeProductData = null;
      activeTriggerBtn = null;
      selectedOptions = [];
    }

    variantModal.querySelectorAll("[data-variant-modal-close]").forEach(function (el) {
      el.addEventListener("click", closeVariantModal);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !variantModal.hidden) closeVariantModal();
    });

    if (variantModalSubmit) {
      variantModalSubmit.addEventListener("click", function () {
        if (!activeProductData) return;

        var required = requiredOptionIndexes(activeProductData);
        var allSelected = required.every(function (index) {
          return Boolean(selectedOptions[index]);
        });
        var match = allSelected ? findMatchingVariant(activeProductData, selectedOptions) : null;

        if (!match || !match.available) {
          if (variantModalError) {
            variantModalError.hidden = false;
            variantModalError.textContent = allSelected
              ? "That option is unavailable."
              : "Please select available options.";
          }
          return;
        }

        var trigger = activeTriggerBtn;
        closeVariantModal();
        if (trigger) {
          trigger.setAttribute("data-variant-id", String(match.id));
          addVariantToCart(match.id, trigger);
        }
      });
    }

    return {
      getProductData: getProductData,
      openVariantModal: openVariantModal,
    };
  }

  function markButtonAdded(btn) {
    btn.classList.add("is-added");
    btn.setAttribute("aria-pressed", "true");
    btn.setAttribute("aria-label", "In cart");
    var textEl = btn.querySelector("[data-chemical-add-text]");
    if (textEl) textEl.textContent = "In cart";
    var icon = btn.querySelector("[data-chemical-add-icon]");
    if (icon) {
      var addedSrc = icon.getAttribute("data-icon-added");
      if (addedSrc) icon.src = addedSrc;
    }
  }

  function addVariantToCart(variantId, btn) {
    var textEl = btn.querySelector("[data-chemical-add-text]");
    var originalText = textEl ? textEl.textContent : "Add to cart";
    var originalHtml = btn.innerHTML;

    btn.disabled = true;
    if (textEl) textEl.textContent = "Adding...";
    else btn.textContent = "Adding...";

    return addToCart(variantId, 1)
      .then(function () {
        markButtonAdded(btn);
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { openDrawer: true } }));
      })
      .catch(function (error) {
        console.error("Chemical by need add to cart error:", error);
        if (textEl) textEl.textContent = originalText;
        else btn.innerHTML = originalHtml;
      })
      .finally(function () {
        btn.disabled = false;
      });
  }

  function bindCartButtons(section, modalApi) {
    section.querySelectorAll("[data-chemical-add]").forEach(function (btn) {
      if (btn.dataset.chemicalBound) return;
      btn.dataset.chemicalBound = "1";

      btn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (btn.disabled || btn.classList.contains("is-added")) return;

        var card = btn.closest("[data-product-card]");
        if (card && card.getAttribute("data-has-variants") === "true" && modalApi) {
          var productData = modalApi.getProductData(btn);
          if (productData) {
            modalApi.openVariantModal(productData, btn);
            return;
          }
        }

        var variantId = btn.getAttribute("data-variant-id");
        if (!variantId) return;
        addVariantToCart(variantId, btn);
      });
    });
  }

  function initChemicalSection(section) {
    if (!section || section.dataset.chemicalReady === "true") return;
    section.dataset.chemicalReady = "true";

    var modalApi = initVariantModal(section);
    bindCartButtons(section, modalApi);

    if (typeof Swiper === "undefined") return;

    var tabs = section.querySelectorAll("[data-chemical-tab]");
    var panels = section.querySelectorAll("[data-chemical-panel]");
    var dropdown = section.querySelector("[data-chemical-dropdown]");
    var dropdownBtn = section.querySelector("[data-chemical-dropdown-btn]");
    var dropdownLabel = section.querySelector("[data-chemical-dropdown-label]");
    var dropdownOptions = section.querySelectorAll("[data-chemical-option]");
    var headerPrev = section.querySelectorAll("[data-chemical-prev]");
    var headerNext = section.querySelectorAll("[data-chemical-next]");
    var swipers = {};
    var activeId = panels[0] ? panels[0].getAttribute("data-chemical-panel") : null;

    function getActiveSwiper() {
      return activeId ? swipers[activeId] || null : null;
    }

    function updateNavState(swiper) {
      if (!swiper) return;
      var isBeginning = swiper.isBeginning;
      var isEnd = swiper.isEnd;

      headerPrev.forEach(function (btn) {
        btn.disabled = isBeginning;
        btn.classList.toggle("swiper-button-disabled", isBeginning);
      });

      headerNext.forEach(function (btn) {
        btn.disabled = isEnd;
        btn.classList.toggle("swiper-button-disabled", isEnd);
      });
    }

    function initPanelSwiper(panel) {
      var id = panel.getAttribute("data-chemical-panel");
      var swiperEl = panel.querySelector("[data-chemical-swiper]");
      var progressEl = panel.querySelector("[data-chemical-progress]");
      if (!id || !swiperEl || swipers[id]) return;

      swipers[id] = new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 12,
        grabCursor: true,
        watchOverflow: true,
        pagination: {
          el: progressEl,
          type: "progressbar",
        },
        breakpoints: {
          769: {
            spaceBetween: 14,
          },
        },
        on: {
          init: function () {
            if (id === activeId) updateNavState(this);
          },
          slideChange: function () {
            if (id === activeId) updateNavState(this);
          },
          reachBeginning: function () {
            if (id === activeId) updateNavState(this);
          },
          reachEnd: function () {
            if (id === activeId) updateNavState(this);
          },
          fromEdge: function () {
            if (id === activeId) updateNavState(this);
          },
        },
      });
    }

    function setActivePanel(target) {
      activeId = target;

      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute("data-chemical-tab") === target;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });

      dropdownOptions.forEach(function (option) {
        var isActive = option.getAttribute("data-chemical-option") === target;
        option.classList.toggle("is-active", isActive);
        if (isActive && dropdownLabel) {
          dropdownLabel.textContent = option.textContent.trim();
        }
      });

      panels.forEach(function (panel) {
        var id = panel.getAttribute("data-chemical-panel");
        var isActive = id === target;
        panel.classList.toggle("is-active", isActive);
        panel.hidden = !isActive;

        if (isActive) {
          initPanelSwiper(panel);
          if (swipers[id]) {
            swipers[id].update();
            updateNavState(swipers[id]);
          }
        }
      });

      if (dropdown) {
        dropdown.classList.remove("is-open");
        if (dropdownBtn) dropdownBtn.setAttribute("aria-expanded", "false");
      }
    }

    panels.forEach(function (panel) {
      if (!panel.hidden) initPanelSwiper(panel);
    });

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        setActivePanel(tab.getAttribute("data-chemical-tab"));
      });
    });

    if (dropdownBtn && dropdown) {
      dropdownBtn.addEventListener("click", function () {
        var isOpen = dropdown.classList.toggle("is-open");
        dropdownBtn.setAttribute("aria-expanded", isOpen ? "true" : "false");
      });
    }

    dropdownOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        setActivePanel(option.getAttribute("data-chemical-option"));
      });
    });

    document.addEventListener("click", function (event) {
      if (!dropdown || !dropdown.classList.contains("is-open")) return;
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove("is-open");
        if (dropdownBtn) dropdownBtn.setAttribute("aria-expanded", "false");
      }
    });

    headerPrev.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var swiper = getActiveSwiper();
        if (swiper) swiper.slidePrev();
      });
    });

    headerNext.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var swiper = getActiveSwiper();
        if (swiper) swiper.slideNext();
      });
    });

    updateNavState(getActiveSwiper());
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-chemical]").forEach(initChemicalSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event.target) return;
    initAll(event.target);
  });
})();
